import {
  branchUsageFromEntitlements,
  type PlanEntitlementsLike,
} from '../../../../../shared/plan-benefits';

export type BranchPlanGateInput = {
  isOwner: boolean;
  multiBranch: boolean | undefined;
  maxBranches: number | null | undefined;
  /** Active branches only — matches plan limit rules and fetchUserBranches. */
  activeBranchCount: number;
};

export function resolveCanAddBranch(input: BranchPlanGateInput): boolean {
  if (!input.isOwner || input.multiBranch !== true) return false;
  const max = input.maxBranches;
  const used = Math.max(0, input.activeBranchCount);
  if (max == null) return true;
  return used < max;
}

export function resolveBranchUsageForManage(
  entitlements: PlanEntitlementsLike,
  activeBranchCount: number,
) {
  return branchUsageFromEntitlements({
    ...entitlements,
    branch_count: Math.max(0, activeBranchCount),
  });
}
